import { Buffer } from 'buffer';
import Crypto from 'crypto';
import { randomBytes } from '@noble/ciphers/webcrypto/utils';
import { KeyEntity } from '@utils/encryption';
var algorithm = 'aes-256-gcm';
/**
 * Encryption data util.
 *
 * @author Ihar Kazlouski
 * @param {Buffer} dataToEncrypt data to encrypt.
 * @param {Buffer} key key.
 * @return {string} encrypted data.
 */

var aesEncryption = function aesEncryption(dataToEncrypt, key) {
  var iv = randomBytes(12);
  var cipher = Crypto.createCipheriv(algorithm, key, iv);
  var encryptedData = Buffer.concat([iv, cipher.update(dataToEncrypt), cipher["final"](), cipher.getAuthTag()]);
  return encryptedData.toString('base64');
};
/**
 * Decrypt data util.
 *
 * @author Ihar Kazlouski
 * @param {string} encryptedData encrypted data.
 * @param {string} key key.
 * @param {string} salt salt.
 * @return {string} decrypted value.
 */


var aesDecryption = function aesDecryption(cipher, key) {
  var iv = cipher.slice(0, 12);
  var authTag = cipher.slice(cipher.length - 16, cipher.length);
  var dataToDecrypt = cipher.slice(12, cipher.length - 16);
  var decipher = Crypto.createDecipheriv(algorithm, key, iv);
  decipher.setAuthTag(authTag);
  var decryptedData = Buffer.concat([decipher.update(dataToDecrypt), decipher["final"]()]);
  return decryptedData;
};

var encryptPinOnSms = function encryptPinOnSms(attempt, smsCode, pin) {
  var iv = Buffer.from(attempt.iv || '', 'base64');
  var salt = Buffer.from(attempt.salt || '', 'base64');
  var aesKey = Crypto.pbkdf2Sync(smsCode, salt, KeyEntity.PBKDF_ITERATIONS_NUMBER, KeyEntity.PBKDF_KEY_LENGTH, KeyEntity.PBKDF_ALGO_DIGEST);
  var cipher = Crypto.createCipheriv(KeyEntity.CIPHER_ALGORITHM, aesKey, iv).setAutoPadding(true);
  var encryptedData = Buffer.concat([cipher.update(pin), cipher["final"]()]);
  return encryptedData.toString('base64');
};

export { aesDecryption, aesEncryption, encryptPinOnSms };